import { Stack } from "@mantine/core";

import { usePartnerConfig } from "@/partner/usePartnerConfig";

import type { TechSupportMetrics } from "../api/types";

import { usePerformanceMetrics, useTotalCallCount } from "../hooks/useMetric";
import { formatEDPSourcedUpdatedTime } from "../utils/getFormattedDate";
import { MetricCard } from "./MetricCard";
import { PacingStatsCard } from "./PacingStatsCard";

interface Props {
    showPacing?: boolean;
}

export function PerformanceMetrics({ showPacing }: Props) {
    const { data: metrics, isLoading: isLoadingMetrics, isError: isMetricsError } = usePerformanceMetrics();
    const { data: numCalls, isLoading: isLoadingCalls, isError: isCallsError } = useTotalCallCount();
    const metricsConfig = usePartnerConfig().performanceMetrics;

    return (
        <Stack data-testid="performance-metrics">
            <MetricCard
                isError={isCallsError}
                isLoading={isLoadingCalls}
                header={`${numCalls?.callCount} calls`}
                body="Total calls"
                updatedTime="Live"
            />
            {metricsConfig.map((conf) => {
                const lastUpdatedKey: `${keyof TechSupportMetrics}LastUpdated` = `${conf.metric}LastUpdated`;
                const updatedTime = formatEDPSourcedUpdatedTime(metrics?.[lastUpdatedKey]);
                const metricQuantity = metrics?.[conf.metric] ?? "N/A";
                const metricHeader = `${metricQuantity}${conf.header}`;

                return (
                    <MetricCard
                        key={conf.metric}
                        isError={isMetricsError}
                        isLoading={isLoadingMetrics}
                        header={metricHeader}
                        body={conf.body}
                        updatedTime={updatedTime}
                    />
                );
            })}
            {showPacing && <PacingStatsCard />}
        </Stack>
    );
}
